const subscriptionsLang = {

}

export default {
  subscriptions: subscriptionsLang
}
